import { render, staticRenderFns } from "./perincom.vue?vue&type=template&id=004cfde9"
import script from "./perincom.vue?vue&type=script&lang=js"
export * from "./perincom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports